import { render, staticRenderFns } from "./banner3.vue?vue&type=template&id=fefddd4e&scoped=true"
import script from "./banner3.vue?vue&type=script&lang=js"
export * from "./banner3.vue?vue&type=script&lang=js"
import style0 from "./banner3.vue?vue&type=style&index=0&id=fefddd4e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefddd4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fefddd4e')) {
      api.createRecord('fefddd4e', component.options)
    } else {
      api.reload('fefddd4e', component.options)
    }
    module.hot.accept("./banner3.vue?vue&type=template&id=fefddd4e&scoped=true", function () {
      api.rerender('fefddd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/bannerTemplate/banner3.vue"
export default component.exports